// Node-style globals a few browser builds of our dependencies still expect.
interface NodeStyleGlobals {
  global: Window
  process: { env: Record<string, string | undefined> }
}

(window as unknown as NodeStyleGlobals).global = window;
(window as unknown as NodeStyleGlobals).process = { env: { DEBUG: undefined } };
